export default __webpack_public_path__ + "static/media/waiting_for_accept.32ebd810.svg";